import { useMemo } from 'react'

import { useCurrencySign } from 'app/common/components-next/currency'

import {
  CompositeTableTemplate,
  renderCellGrayZeros,
} from 'app/common/templates-next/table-template'

import {
  columnKeysRight,
  columnKeysRightHeaders,
  createColumnKeysMain,
  createColumnKeysMainHeaders,
  createData,
  createDataProps,
  createDataTotal,
  createHeaderCells,
  createHeaderCellsProps,
  createTotalDataProps,
  renderTableCell,
  tdPropsByRowAndColumnKey,
} from './table-options'

import { PaymentMethodsDto, ProductDataDto, ProductDataTotalDto, dateKeysFormatDto } from './types'
import { columnKeysLeft, columnKeysLeftHeaders } from './table-options'
import styles from './product-types-splitted.module.scss'

const firstColumnWidht = 300 as const
const lastColumnWidth = 270 as const

type Props = {
  productTypes: ProductDataDto
  total: ProductDataTotalDto
  paymentMethods: PaymentMethodsDto
}

export const ProductTypesSplitted = ({ productTypes, total, paymentMethods }: Props) => {
  const currency = useCurrencySign()

  const tableData = useMemo(() => {
    const dateKeys = Object.keys(total.data_by_date)
    const mainColumnKeys = createColumnKeysMain(dateKeys)
    return {
      columnKeysLeft: columnKeysLeft,
      columnKeysLeftHeaders: columnKeysLeftHeaders,
      columnKeysMain: mainColumnKeys,
      columnKeysMainHeaders: createColumnKeysMainHeaders(dateKeys),
      columnKeysRight: columnKeysRight,
      columnKeysRightHeaders: columnKeysRightHeaders,
      header: createHeaderCells(currency, dateKeysFormatDto, 'DD.MM.YYYY'),
      headerProps: createHeaderCellsProps({ firstColumnWidht, lastColumnWidth }),
      data: createData({
        data: productTypes,
        columnKeysMain: mainColumnKeys,
      }),
      dataProps: createDataProps({ firstColumnWidht, lastColumnWidth }),
      total: createDataTotal({
        totals: { ...paymentMethods, total },
        columnKeysMain: mainColumnKeys,
      }),
      totalProps: createTotalDataProps({ firstColumnWidht, lastColumnWidth }),
    }
  }, [productTypes, total, paymentMethods, currency])

  return (
    <div className={styles.container}>
      <CompositeTableTemplate
        data={tableData}
        renderCell={renderTableCell}
        renderFooterCell={renderCellGrayZeros}
        tdPropsByRowAndColumnKey={tdPropsByRowAndColumnKey}
        className={styles.stickyFix}
        borderTop
      />
    </div>
  )
}
